import { useEffect } from 'react';
import axios from 'axios';
import { useContextData } from '../components/ContextData';

const AxiosSetup = () => {
    const { accessToken } = useContextData();
    
    useEffect(() => {
        if(!accessToken){
        //    navigate("/login")
            return
        }
        // Add a request interceptor to attach the access token to each request
        const interceptor = axios.interceptors.request.use(
            config => {
                if (!config.headers.Authorization) {
                    config.headers.Authorization = accessToken;
                }
                return config;
            },
            error => {
                // Handle request errors
                return Promise.reject(error);
            }
        );

        // Clean up the interceptor when component unmounts
        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, [accessToken]);

    return null; // This component doesn't render anything
};

export default AxiosSetup;